import React from 'react';
import { Link } from 'gatsby';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { truncate } from 'lodash';

import { Col, Container, Row } from '../../../reusecore/Layout';
import Box from '../../../reusecore/Box';
import Text from '../../../reusecore/Text';
import Heading from '../../../reusecore/Heading';
import Sidebar from '../Blog-sidebar';

import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';
import clientConfig from '../../../../../client-config';
import { BlogPageWrapper } from './blogGrid.style';
import { blocksToText } from '../../../../utils/tools';
import SectionTitle from '../../../reusecore/SectionTitle';

const BlogGrid = ({ posts, searchSlug, searchType }) => {
  let title = 'Blog posts';
  if (searchSlug !== '') {
    title =
      searchType === 'tag'
        ? `Blog posts tagged "${searchSlug.toLowerCase()}"`
        : `Blog posts with category "${searchSlug.toLowerCase()}"`;
  }
  return (
    <BlogPageWrapper>
      <Box className="blog-grid-wrapper">
        <Container>
          <SectionTitle UniWidth="65%">
            <Heading as="h2">{title}</Heading>
          </SectionTitle>
          <Row>
            <Col xs={12} lg={9}>
              <Box className="blog-grid-wrapper">
                <Row>
                  {posts?.map((post, index) => {
                    const { heroImage, slug, title, _rawBody, _rawIntro, publishedAt, category, tags } = post;
                    if (searchSlug !== '') {
                      if (searchType === 'tag' && !tags.find((tag) => tag.value.toLowerCase() === searchSlug)) {
                        return;
                      }
                      if (searchType === 'category' && category?.slug.current.toLowerCase() !== searchSlug) {
                        return;
                      }
                    } else {
                      if (category && category?.slug.current.toLowerCase() === 'reviews') {
                        return;
                      }
                    }
                    let formattedDate = '';
                    if (publishedAt) {
                      formattedDate = new Date(publishedAt);
                      formattedDate =
                        (formattedDate.getMonth() > 8
                          ? formattedDate.getMonth() + 1
                          : '0' + (formattedDate.getMonth() + 1)) +
                        '/' +
                        (formattedDate.getDate() > 9 ? formattedDate.getDate() : '0' + formattedDate.getDate()) +
                        '/' +
                        formattedDate.getFullYear();
                    }
                    const gatsbyImageData = getGatsbyImageData(
                      heroImage.image,
                      { layout: 'constrained', maxWidth: 675 },
                      clientConfig.sanity
                    );
                    let intro = '';
                    if (_rawIntro) {
                      intro = truncate(blocksToText(_rawIntro), {
                        length: 150,
                      });
                    } else if (_rawBody) {
                      intro = truncate(blocksToText(_rawBody), {
                        length: 150,
                      });
                    }
                    return (
                      <Col key={index} xs={12} sm={6}>
                        <Box className="post-block">
                          <Box className="post-thumb-block">
                            <Link to={`/blog/${slug.current}`}>
                              <GatsbyImage
                                style={{ width: '100%', height: '100%' }}
                                image={gatsbyImageData}
                                alt={heroImage.alt}
                              />
                            </Link>
                          </Box>
                          <Box className="post-content-block">
                            <Box className="post-meta-block">
                              {category && (
                                <>
                                  <Text as="span">In: </Text>
                                  {category.title}
                                </>
                              )}
                              <Text as="span">{formattedDate}</Text>
                            </Box>
                            <Heading leftAlign as="h2" className="post-title">
                              <Link to={`/blog/${slug.current}`}>{title}</Link>
                            </Heading>
                            {intro}
                            <Link to={`/blog/${slug.current}`} className="readmore-btn">
                              see more <IoIosArrowRoundForward />
                            </Link>
                          </Box>
                        </Box>
                      </Col>
                    );
                  })}
                </Row>
              </Box>
            </Col>
            <Col xs={12} lg={3}>
              <Sidebar />
            </Col>
          </Row>
        </Container>
      </Box>
    </BlogPageWrapper>
  );
};

export default BlogGrid;
